const dimensionList = [
  { key: "1", size: 10 },
  { key: "1x", size: 50 },
  { key: "2x", size: 150 },
  { key: "3x", size: 170 },
  { key: "4x", size: 220 },
  { key: "5x", size: 260 },
  { key: "6x", size: 330 },
  { key: "7x", size: 430 },
  { key: "8x", size: 500 },
  { key: "9x", size: 720 },
  // { key: "10x", size: 1500 },
]

class ImageSourceSizes {
  /**
   * get url of image
   * @param {baseURL} baseURL
   */
  srcSet(baseURL) {
    let srcSet = []

    if (!baseURL)
      return srcSet

    const format = baseURL.split(".");
    const ext = format.length > 1 && format[format.length - 1]
    const fileName = format.splice(0, format.length - 1).join(".")

    dimensionList.map(dim => {
      const url = `${fileName}_${dim.key}.${ext} ${Math.floor(dim.size)}w`;
      srcSet.push(url)
    })

    // console.log('vw:', Math.max(document.documentElement.clientWidth, window.innerWidth || 0))
    // console.log('devicePixelRatio:', devicePixelRatio)
    // console.log('outerWidth:', outerWidth, 'innerWidth:', innerWidth)

    // dimensionList.map(dim => {
    //   const url = `${fileName}_${dim.key}.${ext} ${(dim.size / innerWidth).toFixed(2)}x`;
    //   srcSet.push(url)
    // })

    return srcSet;
  }
};

export default new ImageSourceSizes();
